import React from "react";
import "./FloatingIcons.css";

const FloatingIcons = () => {
  return (
    <div className="floating-icons">
      <a href="https://wa.me/254743594486" className="whatsapp" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-whatsapp"></i>
      </a>
      <a href="https://www.linkedin.com/in/ivy-makokha-922b39277/" className="linkedin" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-linkedin-in"></i>
      </a>
      <a href="https://www.facebook.com/Ivy Ivy" className="facebook" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href="https://www.instagram.com/ivyadisa7" className="instagram" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i>
      </a>
    </div>
  );
};

export default FloatingIcons;
